module.exports = __webpack_public_path__ + "static/media/trampas-01.39921fe9.png";